import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import user from './user';
import card from './card';
import template from './template';
import customCard from './custom-card';
import setting from './setting';
import theme from './theme';
import designer from './designer';
import users from './users';
import announcement from './annoucement';

const userPersistConfig = {
  key: 'user',
  storage,
  blacklist: ['error', 'isPending'],
};

export default combineReducers({
  user: persistReducer(userPersistConfig, user),
  card,
  template,
  customCard,
  setting,
  theme,
  designer,
  users,
  announcement,
});
